import { Skeleton, Typography } from 'antd';
import styled from 'styled-components';
import {FC} from "react";
import {useMediaQuery} from "@uidotdev/usehooks";

const { Text } = Typography;

const CountWrapper = styled.div`
    font-weight: bold;
    margin: 16px 0 0;
    @media (max-width: 767px) {
        margin: -26px 0 0 0;
    }
`;

interface JobCountDisplayProps {
    count: number | undefined;
    isLoading: boolean;
}

export const JobCountDisplay: FC<JobCountDisplayProps> = ({ count, isLoading }) => {
    const isMobile = useMediaQuery("only screen and (max-width : 768px)");

    return (
        <CountWrapper>
            Jobs für Sie: {isLoading ? (
            <Skeleton.Button active={true} style={{ width: 128, height: 16, verticalAlign: 'middle' }} size='small' shape='default' />
        ) : (
            <Text>{`(${count ?? 0}${!isMobile ? " Ergebnisse" : ""})`}</Text>
        )}
        </CountWrapper>
    );
};
